import { render, staticRenderFns } from "./GroupBuyPrice.vue?vue&type=template&id=4311acea&scoped=true&"
import script from "./GroupBuyPrice.vue?vue&type=script&lang=js&"
export * from "./GroupBuyPrice.vue?vue&type=script&lang=js&"
import style0 from "./GroupBuyPrice.vue?vue&type=style&index=0&id=4311acea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4311acea",
  null
  
)

export default component.exports